// src/components/Products/ProductForm.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { createProducto, updateProducto, getProductos } from '../../services/api';
import { AuthContext } from '../../contexts/AuthContext';

const ProductForm = () => {
  const [producto, setProducto] = useState({
    id: '',
    name: '',
    productType: '',
    internalRef: '',
    barcode: '',
    salesPrice: '',
    cost: '',
    weight: '',
    description: '',
    estado: 'Activo',
    usuarioModificacion: '', // Añadido para historial
    observacion: '', // Añadido para historial
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { id } = useParams(); // Para editar
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (id) {
      // Si hay un ID, es edición. Obtener datos del producto.
      const fetchProducto = async () => {
        try {
          const data = await getProductos();
          if (data.success) {
            const existingProducto = data.data.find((prod) => prod.id === id);
            if (existingProducto) {
              setProducto(existingProducto);
            } else {
              setError('Producto no encontrado');
            }
          } else {
            setError('Error al obtener producto');
          }
        } catch (err) {
          setError(err.error || 'Error al obtener producto');
        }
      };
      fetchProducto();
    }
  }, [id]);

  const handleChange = (e) => {
    setProducto({ ...producto, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (id) {
        // Actualizar producto
        const data = await updateProducto(producto);
        if (data.success) {
          navigate('/products');
        } else {
          setError('Error al actualizar producto');
        }
      } else {
        // Crear producto
        const data = await createProducto(producto);
        if (data.success) {
          navigate('/products');
        } else {
          setError('Error al crear producto');
        }
      }
    } catch (err) {
      setError(err.error || 'Error en la operación');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={4} p={4} boxShadow={3}>
        <Typography variant="h5" gutterBottom>
          {id ? 'Editar Producto' : 'Crear Producto'}
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <form onSubmit={handleSubmit}>
          {/* ID solo para edición */}
          {id && (
            <TextField
              label="ID"
              variant="outlined"
              fullWidth
              margin="normal"
              name="id"
              value={producto.id}
              onChange={handleChange}
              disabled
            />
          )}
          <TextField
            label="Nombre"
            variant="outlined"
            fullWidth
            margin="normal"
            name="name"
            value={producto.name}
            onChange={handleChange}
            required
          />
          <TextField
            label="Tipo de Producto"
            variant="outlined"
            fullWidth
            margin="normal"
            name="productType"
            value={producto.productType}
            onChange={handleChange}
            required
          />
          <TextField
            label="Referencia Interna"
            variant="outlined"
            fullWidth
            margin="normal"
            name="internalRef"
            value={producto.internalRef}
            onChange={handleChange}
            required
          />
          <TextField
            label="Código de Barras"
            variant="outlined"
            fullWidth
            margin="normal"
            name="barcode"
            value={producto.barcode}
            onChange={handleChange}
          />
          <TextField
            label="Precio de Venta"
            variant="outlined"
            type="number"
            fullWidth
            margin="normal"
            name="salesPrice"
            value={producto.salesPrice}
            onChange={handleChange}
            required
          />
          <TextField
            label="Costo"
            variant="outlined"
            type="number"
            fullWidth
            margin="normal"
            name="cost"
            value={producto.cost}
            onChange={handleChange}
            required
          />
          <TextField
            label="Peso"
            variant="outlined"
            type="number"
            fullWidth
            margin="normal"
            name="weight"
            value={producto.weight}
            onChange={handleChange}
          />
          <TextField
            label="Descripción"
            variant="outlined"
            fullWidth
            margin="normal"
            name="description"
            value={producto.description}
            onChange={handleChange}
            multiline
            rows={4}
          />
          {/* Campos Añadidos para Historial */}
          {id && (
            <>
              <TextField
                label="Usuario Modificación"
                variant="outlined"
                fullWidth
                margin="normal"
                name="usuarioModificacion"
                value={producto.usuarioModificacion}
                onChange={handleChange}
              />
              <TextField
                label="Observación"
                variant="outlined"
                fullWidth
                margin="normal"
                name="observacion"
                value={producto.observacion}
                onChange={handleChange}
                multiline
                rows={2}
              />
            </>
          )}
          <Box mt={2}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {id ? 'Actualizar' : 'Crear'}
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default ProductForm;
